import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import { sourceAppValues } from '../types';
import Messaging from './Messaging';
import { jsx as _jsx } from "react/jsx-runtime";
const Banner = ({
  alertType,
  closable,
  langPath,
  onClose,
  showCta,
  source
}) => {
  return /*#__PURE__*/_jsx(UIAlert, {
    "data-testid": "account-suspension-banner",
    "data-test-id": "account-suspension-banner",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: langPath.title
    }),
    type: alertType,
    closeable: closable,
    onClose: onClose,
    children: /*#__PURE__*/_jsx(Messaging, {
      langPath: langPath,
      showCta: showCta,
      source: source
    })
  });
};
Banner.propTypes = {
  source: PropTypes.oneOf(sourceAppValues).isRequired,
  alertType: PropTypes.oneOf(['danger', 'success', 'warning']).isRequired,
  showCta: PropTypes.bool.isRequired,
  langPath: PropTypes.shape({
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    cta: PropTypes.string.isRequired
  }).isRequired,
  closable: PropTypes.bool.isRequired,
  onClose: PropTypes.func
};
export default Banner;